import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import PrinterPicker from
  '../../../../Printer/containers/PrinterPicker'
import CamposReimpresionComprobante0 from
  '../../../../Camiones/components/reimpresionComprobante/CamposReimpresionComprobante0'
import { FORM_REIMPRESION_COMPROBANTE } from '../../../../../config/forms'

class ReimpresionComprobanteDescarga0 extends Component {
  constructor (props) {
    super(props)
    this.selectPrinter = this.selectPrinter.bind(this)
    this.onPrinterChange = this.onPrinterChange.bind(this)
  }

  selectPrinter (printer, printerName) {
    this.props.selectPrinterComprobanteDescarga(printer, printerName)
  }

  onPrinterChange () {
    this.props.resetPrinterComprobanteDescarga()
  }

  handleInputChange (e) {
    if (!isNaN(e.target.value)) {
      this.props.descargaUpdateCpa(e.target.value)
    }
    if ((String(e.target.value).length === 12)) {
      this.props.descargaUpdateCpa(e.target.value)
      process.nextTick(this.props.onSubmit)
    }
  }

  render () {
    const {
      handleSubmit,
      descargaImpresora,
      descargaImpresoraNombre,
      iCompletoCpaTextValue,
      invalid
    } = this.props

    return (
      <div className='completo_busqueda_cpa'>
        <form onSubmit={handleSubmit}>
          <PrinterPicker
            onSubmit={this.selectPrinter}
            place='pesado'
            name='printerComprobanteDescarga'
            show={descargaImpresora == null} />
          <CamposReimpresionComprobante0
            onPrinterChange={this.onPrinterChange}
            printerName={descargaImpresoraNombre}
            cpaTextValue={iCompletoCpaTextValue}
            onChange={this.handleInputChange.bind(this)}
          />
          <br />
          <Button
            type='submit'
            variant='primary'
            size='lg'
            disabled={invalid}
          >Imprimir
          </Button>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  descargaImpresora: state.pesado.printerComprobanteDescarga,
  descargaImpresoraNombre: state.pesado.printerNameComprobanteDescarga,
  invalid: isInvalid(FORM_REIMPRESION_COMPROBANTE)(state),
  descargaCpaTextValue: state.pesado.descargaCpaTextValue
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_REIMPRESION_COMPROBANTE,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(ReimpresionComprobanteDescarga0))
